export default __webpack_public_path__ + "static/media/customerss.955bec13.jpg";